import React, { useContext, useState } from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";
import MobileContext from "../../context";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

const solutions = [
  {
    css: "b1",
    title: "$singlee_yl8",
    desc: "$singlee_yl3",
  },
  {
    css: "b2",
    title: "$singlee_yl9",
    desc: "$singlee_yl4",
  },
  {
    css: "b3",
    title: "$singlee_yl10",
    desc: "$singlee_yl5",
  },
  {
    css: "b4",
    title: "$singlee_yl11",
    desc: "$singlee_yl6",
  },
];
const pics = [
  require("assets/medical/s1.png"),
  require("assets/medical/s2.png"),
  require("assets/medical/s3.png"),
  require("assets/medical/s4.png"),
];

function Index() {
  const { t } = useTranslation();
  const mobile = useContext(MobileContext);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [firtstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(-100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.2, once: true }
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.2, once: true }
  );
  const [thirdRef, thirdRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.2, once: true }
  );

  return (
    <div className={css.contain}>
      {previewUrl ? (
        <div
          className={css.preview}
          onClick={() => setPreviewUrl(null)}
          style={{ height: `${window.innerHeight}px` }}
        >
          <img src={previewUrl} alt="" />
        </div>
      ) : null}
      <div className={css.maintitle}>{t("$singlee_yl1")}</div>

      <div className={css.first} ref={firtstRef}>
        <animated.div className={css.left} style={firstRefStyle}>
          <div className={css.title}>{t("$singlee_js")}</div>
          <div className={css.desc}>{t("$singlee_yl2")}</div>
        </animated.div>
        <div className={css.right}></div>
      </div>

      <div className={css.second} ref={secondRef}>
        <div className={css.subtitle}>{t("解决方案")}</div>
        <animated.div className={css.inner} style={secondRefStyle}>
          {solutions.map((item, index) => (
            <div className={css.item} key={index}>
              <div className={`${css.icon} ${css[item.css]}`}></div>
              <div className={css.title}>{t(item.title)}</div>
              <div className={css.desc}>{t(item.desc)}</div>
            </div>
          ))}
        </animated.div>
      </div>

      <div className={css.third} ref={thirdRef}>
        <div className={css.subtitle}>{t("案例分享")}</div>
        <div className={css.secondtitle}>{t("$singlee_yl7")}</div>
        <animated.div className={css.inner} style={thirdRefStyle}>
          {mobile ? (
            <Swiper
              pagination={{ bulletActiveClass: css.currentClass }}
              slidesPerView={1}
              spaceBetween={30}
              grabCursor={true}
              modules={[Pagination]}
              className={css.cardSwiper}
            >
              {pics.map((item, index) => {
                return (
                  <SwiperSlide
                    className={`${css.cardboxOut}`}
                    key={index}
                    onClick={() => setPreviewUrl(item)}
                  >
                    <div className={css.item}>
                      <div className={css.picbox}>
                        <img src={item} alt="" />
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <div className={css.flexbox}>
              {pics.map((item, index) => {
                return (
                  <div
                    className={css.item}
                    key={index}
                    onClick={() => setPreviewUrl(item)}
                  >
                    <div className={css.picbox}>
                      <img src={item} alt="" />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </animated.div>
      </div>
    </div>
  );
}

export default React.memo(Index);
